exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-1f049c57] .el-loading-mask{background-color:transparent!important}.video-icon[data-v-1f049c57]{font-size:32px;cursor:pointer;color:#fff}.video-icon[data-v-1f049c57]:hover{color:#558acc}", ""]);

// exports
